const state = {
    drawer: false,
    alert: {
        type: null,
        message: null
    }
};
const actions = {};
const mutations = {
    addAlert(state, { type, message }) {
        state.alert.type = type ? type : "success";
        state.alert.message = message;
    },
    dismissAlert(state) {
        state.alert.type = null;
        state.alert.message = null;
    }
};
const getters = {
    drawer: state => state.drawer,
    alert: state => state.alert
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
